import client from "../utils/ApiHelper.js";
import ErrorException from "../utils/Exceptions.js";

async function fetchSummary() {
    try {
        let res = await client.get("/dashboard/summary");

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function fetchMostUsed() {
    try {
        let res = await client.get("/dashboard/most-used");

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function fetchUnderStock() {
    try {
        let res = await client.get("/dashboard/under-stock");

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function fetchRackStorage() {
    try {
        let res = await client.get("/dashboard/rack-storage");

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

async function fetchActivityReport() {
    try {
        let res = await client.get("/dashboard/activity-report");

        return res.data;
    } catch (err) {
        throw ErrorException(err);
    }
}

export {
    fetchSummary,
    fetchMostUsed,
    fetchUnderStock,
    fetchRackStorage,
    fetchActivityReport,
};